module.exports = __webpack_public_path__ + "static/media/warning.40847e9d.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/warning.svg
// module id = 1151
// module chunks = 1